<template>
  <v-app id="inspire">
    <Header />

    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      offset-y
      v-if="user.name"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="blue"
          dark
          fixed
          top
          right
          fab
          style="z-index:10 !important"
          v-on="on">
            {{getLetter(user?user.name.replace(' ', '+'):'')}}
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>

            <v-list-item-content>
              <v-list-item-title>{{user?user.name:''}}</v-list-item-title>
              <v-list-item-subtitle>{{user?user.acesso:''}}</v-list-item-subtitle>
            </v-list-item-content>

          </v-list-item>
          <!-- <v-list-item >
            <v-switch
              v-model="$vuetify.theme.dark"
              hide-details
              inset
              v-on:change="changeTema($vuetify.theme.dark)"
              label="Tema Escuro"
            ></v-switch>
          </v-list-item> -->
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item @click.stop="setDrawer(!drawer); menu = !menu">
            <v-list-item-title>Menu</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="user && user.acesso != 'Devedor'" @click.stop="setDrawerRight(!drawerRight); menu = !menu">
            <v-list-item-title>Chat</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="logout()" >
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>

      </v-card>
    </v-menu>

    
    <v-content 
      v-bind:class="[!isLoggin||isDesconto ? 'content-main' : '']"
      class="fill-height"
      fluid
      >
      <!--v-layout row v-if="error">
        <v-flex xs12 sm6 offset-sm3>
          <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-flex>
      </v-layout-->
      <transition name="fade-transform" mode="out-in">
        <router-view></router-view>
      </transition>
      
    </v-content>
    
    <v-dialog v-model="error" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Observação</v-card-title>
        <v-card-text >{{error}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="errorTest();"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-footer v-show="isLoggin&&isDesconto" style="height: 60px;">
      <v-layout row wrap align-center style="height: 100px; !important">
        <v-flex xs12 class="black-gray footer" style="height: 100px; !important">
          <div class="white--text" style="height: 100px; !important">
            
            <v-layout row style="height: 100px; !important">
              <v-flex xs2 sm3 offset-sm1>
              </v-flex>
              
              <v-flex xs10 sm4 class="footer" >
                <span nowrap>TODOS OS DIREITOS RESERVADOS A CASA BRAZIL</span>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-footer> -->
  </v-app>
</template>

<script>
import Header from './components/Header';
import AppAlert from './components/shared/AppAlert';
import { mapMutations } from "vuex";
import store from "@/store";
import usuario from "@/services/usuario";

export default {
  components: {
    AppAlert,
    Header
  },
  data () {
    return {
      title: 'Vuetify.js',
      scrolled: false,
      dialogError: false,
      menu: false
    }
  },
  methods: {
    errorTest () {
      this.dialogError = false;
      this.$store.dispatch('clearError')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    handleScroll () {
      if (this.$store.getters.user) {
        this.scrolled = true;
      } else {
        this.scrolled = window.scrollY > 0;
      }
    },
    getLetter (name) {
      return name.substring(0,1)+name.substring(name.lastIndexOf("+")+1,name.lastIndexOf("+")+2);
    },
    logout () {
      this.menu = false;
      this.$router.push('/logout')
    },
    // changeTema (tema) {
    //   localStorage.setItem('themeCache', tema);
    // },
    ...mapMutations({
      setLoading: "setLoading",
      setDrawerRight: "setDrawerRight",
      setDrawer: "setDrawer",
    }),
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    localStorage.setItem('themeCache', true);
  },
  
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    
    error () {
      if (this.$store.getters.error) {
        this.dialogError = true;
      } else {
        this.dialogError = false;
      }
      return this.$store.getters.error
    },
    isLoggin () {
      if (this.$store.getters.user) {
        return true
      } else {
        return false;
      }
    },
    user () {
      return this.$store.getters.user;
    },
    isDesconto () {
      return this.$store.getters.desconto;
    },
    isUser () {
      if (!this.$store.getters.user) {
        return false;
      } else {
        usuario.getUsuario(this.$store.getters.user._id).then(res => {
          if (res != null && res.grand == "Cliente") {
            return false;
          } else {
            return true;
          }
        });
      }
    },
    drawerRight () {
      return this.$store.getters.drawerRight;
    },
    drawer () {
      return this.$store.getters.drawer;
    }
  },
  asyncComputed: {
    async user () {
      if (store.getters.user) {
        return await usuario.getUsuario(store.getters.user._id);
      } else {
        return {};
      }
      
    },
  }
}
</script>
<style>
  html {
    font-size: 14px !important;
    font-weight: 400;
    font-family: Arial !important;
  }
  .v-window {
    padding: 10px;
  }
  .v-data-table tr {
    height: 36px;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.750rem;
    height: 36px;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 5px;
  }
  .v-data-table > td, .v-data-table > th {
    padding: 0 10px;
  }
  .v-application {
    font-family: Arial !important;
    line-height: 1.5;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  .v-text-field input {
    line-height: 14px !important;
    padding: 0px 0 0px !important;
  }
  .v-label {
    font-size: 12px !important;
  }
  .v-text-field--outlined .v-label--active {
    transform: translateY(-20px) scale(0.75);
  }
  .v-input__slot {
    margin-bottom: 0px !important;
    min-height: 40px !important;
  }
  .v-text-field--outlined .v-label {
    top: 10px !important;
  }
  .v-subheader {
    padding: 0 0px 0 0px;
  }
  .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
  }
  .col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
    padding: 0 10px;
  }
  .v-input {
    font-size: 14px !important;
  }
  .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer {
    margin-top: 10px !important;
  }

  @font-face {
      font-family: Montserrat-Black;
      src: url("/static/fonts/Montserrat-Black.otf") format("opentype");
  }

  @font-face {
      font-family: Montserrat-Bold;
      src: url("/static/fonts/Montserrat-Bold.otf") format("opentype");
  }

  @font-face {
      font-family: Montserrat-Regular;
      src: url("/static/fonts/Montserrat-Regular.otf") format("opentype");
  }
  /* fade */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.28s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  /* fade-transform */
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .5s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  /* breadcrumb transition */
  .breadcrumb-enter-active,
  .breadcrumb-leave-active {
    transition: all .5s;
  }

  .breadcrumb-enter,
  .breadcrumb-leave-active {
    opacity: 0;
    transform: translateX(20px);
  }

  .breadcrumb-move {
    transition: all .5s;
  }

  .breadcrumb-leave-active {
    position: absolute;
  }

  .content-main {
    padding: 0 !important;
  }
  /*.toolbar-titlew {
    border-bottom: 5px solid white !important;
  }*/
  .toolbar-shrink {
    background-color: white !important;
  }
  .v-btn__content {
    white-space: normal !important;
    text-transform: none;
  }
  .barcode {
    height: 20px;
  }
  .footer {
    text-align: center;
    line-height: 120px; 
    white-space: nowrap !important;
    color: black;
    font-family: 'Montserrat-Regular', sans-serif !important;
  }
  .black-gray {
    background-image: linear-gradient(-90deg, #dbdaca 65%, black 35%);
  }
  
</style>



// WEBPACK FOOTER //
// src/App.vue